import $ from 'jquery';
import { Component } from 'react';

import KudoDisplay from '../components/KudosDisplay';
import ActionsDisplay from '../components/ActionsDisplay';

class ActionsAndKudos extends Component {
  constructor() {
    super();
    this.state = {
      takeaways: [],
      takeawaysCount: 0,
      kudos: [],
      kudosCount: 0,
    };
  }

  componentDidMount() {
    this.getTakeaways();
    this.getKudos();
  }

  getKudos() {
    // prettier-ignore
    $.ajax({ // eslint-disable-line no-undef
      url: `/api/v1/coaching/kudo${window.location.search}`,
      dataType: 'json',
      cache: false,
      success: function (response) { // eslint-disable-line func-names
        const { kudos, kudosCount } = response;
        this.setState({
          kudos,
          kudosCount,
        });
      }.bind(this),
    });
  }

  getTakeaways() {
    // prettier-ignore
    $.ajax({ // eslint-disable-line no-undef
      url: `/api/v1/coaching/takeaway${window.location.search}`,
      dataType: 'json',
      cache: false,
      success: function (response) { // eslint-disable-line func-names
        const { takeaways, takeawaysCount } = response;
        this.setState({
          takeaways,
          takeawaysCount,
        });
      }.bind(this),
    });
  }

  render() {
    const { kudos, kudosCount, takeaways, takeawaysCount } = this.state;

    if (takeawaysCount === 0 && kudosCount === 0) return null;
    return (
      <div className="takeaways-container takeaways-display">
        <div className="widget-header">
          <div className="title">
            <span>Actions & Kudos</span>
          </div>
        </div>
        <div className="takeaways-display-wrap">
          {kudos.map(
            kudo => kudo.text && <KudoDisplay key={kudo.id} {...kudo} />,
          )}
          {takeaways.map(takeaway => (
            <ActionsDisplay key={takeaway.id} {...takeaway} />
          ))}
        </div>
      </div>
    );
  }
}

export default ActionsAndKudos;
